import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import GalleryIcon from '@ps-design-system/icons/GalleryPhoto/GalleryPhoto24';

export const ExpandAttachments = ({ isExpanded, onClick }) => {
  return (
    <button type="button" onClick={onClick} className="Attachment ExpandAttachments flex center middle">
      <div className="flex column center middle">
        <GalleryIcon height={24} width={24} className="margin-md-bottom" />
        <div className="heavier">
          {isExpanded
            ? <FormattedMessage
              id="stream.expand_attachments.hide"
              defaultMessage="Hide"
            />
            : <FormattedMessage
              id="stream.expand_attachments.view_all"
              defaultMessage="View all"
            />
          }
        </div>
      </div>
    </button>
  );
};

ExpandAttachments.propTypes = {
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func
};
